import TownBuyerLandingPage from "./TownBuyerLandingPage";
const MarltonLanding = () => (
  <TownBuyerLandingPage townName="Marlton" slug="homes-for-sale-marlton" savedLinkId="10356" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-marlton-ac" />
);
export default MarltonLanding;
